export default {

    NEWSLETTERS: {
        PAGE: {
            LIST: 'list',
            CARDS: 'cards',
            TUTO: 'tuto'
        },
        CATEGORIES: {
            ALL: 'all',
            SUBSCRIPTIONS: 'subscriptions',
            SPAMS: 'spams',
            AUTO_DELETE: 'auto-delete',
            KEEP: 'keep'
        },
        ACTIONS: {
            UNSUBSCRIBES: 'unsubscribes',
            DELETE: 'delete',
            KEEP: 'keep'
        },
        SORT: {
            NOT_SET: 'notSet',
            ASCENDING: 'ascending',
            DESCENDING: 'descending',
            MOST_OPEN: 'mostOpen',
            LEAST_OPEN: 'leastOpen'
        },
        CARDS: {
            GREENFOX: 'greenfox',
            MARKET: 'market',
            SHARING: 'sharing',
            SUBSCRIPTIONS: 'subscriptions'
        },
        SEARCHING_MODE: {
            UNACTIVE: 'unactive',
            SEARCHING: 'searching',
            RESULT: 'result'
        }
    },
    NOTIFICATIONS: {
        DEFAULT: 'default',
        GRANTED: 'granted',
        DENIED: 'denied'
    },
    STEPS: {
        TUTO: {
            UNSUBSCRIBES: 'unsubscribes',
            DELETE: 'delete',
            KEEP: 'keep',
            SPAMS: 'spams',
            END: 'end'
        },
        HELP: {
            UNSUBSCRIBES: 'unsubscribes',
            DELETE: 'delete',
            KEEP: 'keep'
        }
    },
    LOGIN_STATUS: {
        CREATED: 'created',
        ASSOCIATED: 'associated',
        IMPORTED: 'imported',
        RECONNECTED: 'reconnected',
        RECONNECTED_INVALID_GRANT: 'reconnected-invalid-grant',
        MAGIC_LINK: 'magic-link'
    },
    FETCH_STATUS: {
        DONE: 'done',
        PENDING: 'pending',
        PARTIAL: 'partial',
        INITIAL: ''
    },
    DIRECTIONS: {
        UP: 'up',
        RIGHT: 'right',
        DOWN: 'down',
        LEFT: 'left'
    },
    LOGIN_FLOW_GOOGLE: {
        STEPS: {
            DOUBLE_AUTH: 'double_auth',
            APP_PASS: 'app_pass',
            LOGIN: 'login'
        },
        ACTIONS: {
            OPEN_DOUBLE_AUTH: 'open_double_auth',
            OPEN_APP_PASS: 'open_app_pass',
            VALID_DOUBLE_AUTH: 'valid_double_auth',
            VALID_APP_PASS: 'valid_app_pass',
            LOGIN: 'login',
            BACK: 'back'
        }
    }
}
